import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Box } from "@mui/material";
import type { RiskBucket } from "../types";
import DashboardCard from "./DashboardCard";
import { PendingCardBody } from "./PendingValue";
import RiskDonut, { RiskLegend } from "./RiskDonut";

/** The risk carried today next to the risk left once every mitigation is done. */
export default function CurrentVsResidualCard({
  baseline,
  residual,
}: {
  baseline: RiskBucket[];
  residual: RiskBucket[];
}) {
  const total = baseline.reduce((sum, bucket) => sum + bucket.count, 0);

  return (
    <DashboardCard title="Current vs Residual Risk">
      {total === 0 ? (
        <PendingCardBody hint="No SPOF matches the current selection." />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <RiskDonut buckets={baseline} centerLabel="Current" size={168} />
            <ArrowRightAltIcon sx={{ color: "text.disabled" }} />
            <RiskDonut buckets={residual} centerLabel="Residual" size={168} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            <RiskLegend buckets={residual} compact />
          </Box>
        </>
      )}
    </DashboardCard>
  );
}
